import MarkdownResponse from "./MarkdownResponse/MarkdownResponse";
import Support from "./Cosmic/Support";
import { Stack, StackItem } from "@fluentui/react";
import FeedbackModal from "./FeedbackModal";
import { FeedbackStatus } from "../../constants/SettingConstant";

const keywords = ["I'm not aware of the answer"];

export const appendList = (message, name, initials, c, showCosmicButton, showFeedbackOptions, suggestedQuestions, isSupportAssistanceRequired, feedbackStatus, csvDownloadData ) => {
	const isMatch = keywords.some((keyword) => message.toLowerCase().includes(keyword.toLowerCase())) || isSupportAssistanceRequired;
	const cosmicPresent = showCosmicButton && isMatch;
	return {
		key: c,
		index:0,
		cosmicPresentKey: cosmicPresent,
		suggestedQuestions: suggestedQuestions,
		feedbackPresentKey: showFeedbackOptions,
		csvDownloadData: csvDownloadData || null, // AI - store for download button
		// activityDescription: [
		// 	<span key={1} className="nameText">
		// 		{" "}
		// 		{name}
		// 	</span>
		// ],
		activityPersonas: [{ imageInitials: "", text: initials, initialsColor: "" }],
		commentText: message,
		comments: [
			<span key={1} className="messageText">
				<MarkdownResponse  content={message} />
				<Stack horizontal className="response-footer-stack">
					<StackItem className="response-footer-left">{showCosmicButton && isMatch && <Support></Support>}
						{/* AI - CSV download button in footer row */}
						{csvDownloadData && <button className="csv-download-button" onClick={() => {
							try {
								const byteCharacters = atob(csvDownloadData.base64Content);
								const byteNumbers = new Array(byteCharacters.length);
								for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters.charCodeAt(i); }
								const byteArray = new Uint8Array(byteNumbers);
								const blob = new Blob([byteArray], { type: "text/csv" });
								const url = window.URL.createObjectURL(blob);
								const link = document.createElement("a");
								link.href = url;
								// AI - Add timestamp to filename
								const timestamp = new Date().toISOString().split('T')[0];
								const formattedFileName = csvDownloadData.fileName.replace('.csv', '') + '-' + timestamp + '.csv';
								link.download = formattedFileName;
								document.body.appendChild(link);
								link.click();
								document.body.removeChild(link);
								window.URL.revokeObjectURL(url);
							} catch (e) { console.error("CSV download failed:", e); }
						}}><i className="ms-Icon ms-Icon--Download" aria-hidden="true"></i> Download Results</button>}
					</StackItem>
					<StackItem>{(showFeedbackOptions || feedbackStatus == FeedbackStatus.PositveFeedback || feedbackStatus == FeedbackStatus.NegativeFeedback) && <FeedbackModal feedbackStatus={feedbackStatus} />}</StackItem>
				</Stack>
			</span>
		]
		// timeStamp: getTimeStamp()
	};
};
